export const OPEN_SUPPLIER_DRAWER = 'OPEN_SUPPLIER_DRAWER';
export const CLOSE_SUPPLIER_DRAWER = 'CLOSE_SUPPLIER_DRAWER';
export const TOGGLE_SUPPLIER_DRAWER = 'TOGGLE_SUPPLIER_DRAWER';
export const TOGGLE_SUPPLIER_POPOVER = 'TOGGLE_SUPPLIER_POPOVER';
export const REPORT_SUPPLIER_ERROR = 'REPORT_SUPPLIER_ERROR';
export const SET_KEYBOARD_ITEM_TO_EDIT = 'SET_KEYBOARD_ITEM_TO_EDIT';
export const UPDATE_KEYBOARD_ITEM = 'UPDATE_KEYBOARD_ITEM';
export const SET_QUANTITY_OVERWRITE = 'SET_QUANTITY_OVERWRITE';
export const SET_SUPPLIER = 'SET_SUPPLIER';
